import Password from "./Password";
import "./index.scss";
const initPassword = (element) => {
    new Password(element);
}

export {
    Password,
    initPassword
}
